var React = require('react');
var Frame = require('../../views/Frame');
var Extras = require('../../../data/extras.json');

var TrioFunnelAnimations = require('../../../animations/trioFunnel');

var createSprite = require('../../../lib/createSprite');
var spritesHelper = require('../../../lib/spritesHelper');
var Utils = require('../../../lib/utils');
var Audio = require('../../../lib/audio');

var TrioFunnel = React.createClass({
    propTypes: {
        index: React.PropTypes.number,
        intensity: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        backgroundKey: React.PropTypes.string,
        className: React.PropTypes.string,
        trioPersons: React.PropTypes.array,
        trioPositions: React.PropTypes.array,
        fluxRefWidth: React.PropTypes.number,
        fluxRefHeight: React.PropTypes.number,
        solo: React.PropTypes.bool,

        titles: React.PropTypes.array,
        roles: React.PropTypes.array,
    },

    contextTypes: {
        minIntensity: React.PropTypes.number,
        maxIntensity: React.PropTypes.number,
        language: React.PropTypes.string,
    },

    timeline: null,
    sprites: null,
    pixiFlux: null,
    currentTrioState: null,
    audios: null,
    trioTexts: null,

    getDefaultProps: function()
    {
        return {
            trioTexts: null,
            trioTextsStyles: [
                {
                    x: 50,
                    y: 520
                },
                null,
                {
                    align: 'right',
                    x: 1030,
                    y: 520
                }
            ],
            className: 'trio-funnel',
            trioPersons: ['baldGuy', 'charles', 'girl'],
            trioPositions: ['left', 'middle', 'right', 'rotation'],
            solo: false,
            minister: false,
            fluxSettings: require('../../../flux/trioFunnel'),
            audioUrls: {
                flux: ['/audio/28nov/general-liquide-mouv-02.ogg', '/audio/28nov/general-liquide-mouv-02.mp3'],
            },

            titles: ['mitch', 'catherine'],
            roles: ['mitch_title', 'catherine_title']
        };
    },

    render: function()
    {
        let texts = [];
        if (this.props.solo === true) {
            texts = _.merge(this.props.texts, [
                {
                    title: Extras['mitch'].text[this.context.language],
                    subtitle: Extras['mitch_title'].text[this.context.language],
                },
            ]);
        }
        // if (this.props.minister === true) {
        //     texts = _.merge(this.props.texts, [
        //         {
        //             title: Extras['catherine'].text[this.context.language],
        //             subtitle: Extras['catherine_title'].text[this.context.language],
        //         },
        //     ]);
        // }
        return (
            <Frame
                {...this.props}
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onIntensityChanged={this.updateIntensity}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                texts={texts}
            />
        );
    },

    build: function(container, timeline, opts)
    {
        this.sprites = {
            container: container
        };
        this.timeline = timeline;
        this.pixiFlux = opts.pixiFlux;

        this.trioTexts = this.getTexts();

        this.audios = {};
        _.forOwn(this.props.audioUrls, _.bind(function(value, key){
            this.audios[key] = new Audio(value, {
                loop: true,
                channel: 'frame'
            });
        }, this));

        this.buildObjects();
        this.animateObjects();
    },

    getTexts: function() {
        const trioTexts = [
            {
                title: 'Mitch\nROTH',
                subtitle: 'PDG\nBanque Centrale',
            },
            {
                title: 'Jim Baxter',
                subtitle: 'PDG Banque\nd\'investissement',
            },
            {
                title: 'CATHERINE\nSUMMERS',
                subtitle: 'Ministre\ndes finances',
            },
        ];

        const titles = ['mitch', 'tim', 'catherine'];
        const roles = ['mitch_title', 'tim_title', 'catherine_title'];

        return trioTexts.map((text, idx) => {
            return _.merge(text,
                {
                    title: Extras[titles[idx]].text[this.context.language],
                    subtitle: Extras[roles[idx]].text[this.context.language],
                },
            );
        });
    },

    play: function()
    {
        if (this.audios.flux) {
            this.audios.flux.fadeInFast();
        }
    },

    pause: function()
    {
        if (this.audios.flux) {
            this.audios.flux.fadeOutFast();
        }
    },

    destroy: function()
    {
        Object.keys(this.audios).forEach((audioKey) => {
            this.audios[audioKey].destroy();
            this.audios[audioKey] = null;
        });

        if (this.sprites) {
            // console.log('kill sprites triofunnel', this.sprites);
            Object.keys(this.sprites).forEach(key => (
                TweenMax.killTweensOf(this.sprites[key])
            ));
        }

        this.sprites = null;
        this.audios = null;
    },

    buildObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;
        var objs = props.objs;
        var container = sprites.container;

        var i, j, k, il, jl, kl;

        var fluxMask = new PIXI.Graphics();
        fluxMask.beginFill(0xFFFFFF);
        fluxMask.drawRect(0, props.height * 0.464, props.width, props.height * 0.396);
        fluxMask.moveTo(0, 0);
        fluxMask.lineTo(0, props.height * 0.13);
        fluxMask.lineTo(props.width * 0.18, props.height * 0.132);
        fluxMask.lineTo(props.width * 0.411, props.height * 0.278);
        fluxMask.lineTo(props.width * 0.597, props.height * 0.278);
        fluxMask.lineTo(props.width * 0.846, props.height * 0.132);
        fluxMask.lineTo(props.width, props.height * 0.13);
        fluxMask.lineTo(props.width, 0);
        fluxMask.endFill();

        var offset = .29;

        // funnel
        var funnerUnderObj = objs.funnelUnder;
        var funnelUnder = sprites.funnelUnder = createSprite(funnerUnderObj);
        Utils.setSizeAndPositionFromRefSize(funnelUnder, props.width, props.height * offset, funnerUnderObj);
        // funnelUnder.y -= offset;

        var funnelOverObj = objs.funnelOver;
        var funnelOver = sprites.funnelOver = createSprite(funnelOverObj);
        Utils.setSizeAndPositionFromRefSize(funnelOver, props.width, props.height * offset, funnelOverObj);
        // funnelOver.y -= offset;

        var funnelLidObj = objs.funnelLid;
        var funnelLid = sprites.funnelLid = createSprite(funnelLidObj);
        Utils.setSizeAndPositionFromRefSize(funnelLid, props.width, props.height * offset, funnelLidObj);
        // funnelLid.y -= offset;

        // flux
        var fluxContainer = new PIXI.Container();
        if (this.pixiFlux)
        {
            this.pixiFlux.setContainer(fluxContainer, props.width);
        }
        fluxContainer.mask = fluxMask;

        // trio
        var trioPersons = props.trioPersons;
        var trioPositions = props.trioPositions;
        var trioObj;
        var trioKey;
        var trioContainer;
        var trioPosition;
        var sprite;

        for (i = 0, il = trioPositions.length; i < il; i++)
        {
            trioPosition = trioPositions[i];
            trioPosition = trioPosition.charAt(0).toUpperCase()+trioPosition.substr(1);
            trioContainer = sprites['trio'+trioPosition] = new PIXI.Container();
            trioContainer.userData = {character: true};
            for (j = 0, jl = trioPersons.length; j < jl; j++)
            {
                trioKey = trioPersons[j]+trioPosition;
                if (trioPosition === 'Left')
                {
                    for (k = minIntensity; k <= maxIntensity; k++)
                    {
                        trioObj = objs[trioKey+k];
                        sprite = sprites[trioKey+k] = createSprite(trioObj);
                        Utils.setSizeAndPositionFromRefSize(sprite, props.width, props.height, trioObj);
                        trioContainer.addChild(sprite);
                        sprite.visible = false;
                        sprite.userData = {
                            initialPosition: {
                                x: sprite.x,
                                y: sprite.y
                            }
                        }
                    }
                } else if (!props.solo) {
                    trioObj = objs[trioKey];
                    sprite = sprites[trioKey] = createSprite(trioObj);
                    Utils.setSizeAndPositionFromRefSize(sprite, props.width, props.height, trioObj);
                    trioContainer.addChild(sprite);
                    sprite.visible = false;
                    sprite.userData = {
                        initialPosition: {
                            x: sprite.x,
                            y: sprite.y
                        }
                    }
                }
            }
        }

        if (!props.solo) {
            sprites.trioMiddle.visible = false;
            container.addChild(sprites.trioMiddle);
        }

        container.addChild(funnelUnder);
        container.addChild(funnelOver);
        container.addChild(sprites.trioLeft);

        if (!props.solo) {
            container.addChild(sprites.trioRight);
            container.addChild(sprites.trioRotation);
        }

        container.addChild(fluxContainer);
        container.addChild(fluxMask);
        container.addChild(funnelLid);

        if (!props.solo) {
            var allTextsContainer = sprites.allTextsContainer = new PIXI.Container();
            container.addChild(allTextsContainer);
            allTextsContainer.alpha = 0;
            // texts qui changent selon position
            _.each(props.trioTextsStyles, (textStyle, index) => {
                if (textStyle) {
                    var trioText = this.trioTexts[index];
                    var textContainer = sprites['trioTexts'+index] = spritesHelper.createTitles(trioText.title, trioText.subtitle, _.extend({
                        scale: props.scale,
                    }, textStyle));
                    allTextsContainer.addChild(textContainer);
                }
            });
        }
    },

    animateObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var objects = props.objs;

        var intensity = props.intensity;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;

        var timeline = this.timeline;

        this.currentTrioState = {
            pos: -1,
            sprites: null,
            leftAnimations: {},
            rotationAnimations: {},
            leftAnimation: null,
            rightAnimations: {},
            rightAnimation: null
        };

        timeline.add(TrioFunnelAnimations.getFunnelTrioTimeline(sprites, this.currentTrioState, {
            pixiFlux: this.pixiFlux,
            intensity: intensity,
            minIntensity: minIntensity,
            maxIntensity: maxIntensity,
            solo: props.solo,
            trioPersons: props.trioPersons
        }), 0);

        if (this.props.onAnimationReady)
        {
            this.props.onAnimationReady(timeline);
        }
    },

    updateIntensity: function(prevIntensity)
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;

        var intensity = props.intensity;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;

        prevIntensity = typeof prevIntensity !== 'undefined' ? prevIntensity : intensity;

        if (prevIntensity !== intensity && props.play)
        {
            TrioFunnelAnimations.updateFunnelTrioIntensity(props.width, props.height, sprites, intensity, this.currentTrioState, {
                solo: props.solo,
                onAnimationComplete: !props.solo ? this.onRotationComplete : null
            });

            if (!props.solo)
            {
                this.onRotationStart();
            }
        }
    },

    onRotationStart: function()
    {
        var sprites = this.sprites;
        var leftText = sprites['trioTexts0'];
        var rightText = sprites['trioTexts2'];

        TweenMax.to([leftText, rightText], 0.2, {
            alpha: 0,
            ease: Quad.easeIn
        });
    },

    onRotationComplete: function()
    {
        var sprites = this.sprites;
        var props = this.props;

        var leftText = sprites['trioTexts0'];
        var rightText = sprites['trioTexts2'];
        var leftTextTitle = leftText.getChildByName('title');
        var leftTextSubtitle = leftText.getChildByName('subtitle');
        var rightTextTitle = rightText.getChildByName('title');
        var rightTextSubtitle = rightText.getChildByName('subtitle');


        var leftTextIndex, rightTextIndex;
        switch (this.currentTrioState.pos)
        {
            case 0:
                leftTextIndex = 0;
                rightTextIndex = 2;
            break;
            case 1:
                leftTextIndex = 2;
                rightTextIndex = 1;
            break;
            case 2:
                leftTextIndex = 1;
                rightTextIndex = 0;
            break;
        }

        var trioTexts = this.getTexts();

        var trioTextLeft = trioTexts[leftTextIndex];
        var trioTextRight = trioTexts[rightTextIndex];

        leftTextTitle.text = trioTextLeft.title.toUpperCase();
        leftTextSubtitle.text = trioTextLeft.subtitle.toUpperCase();
        rightTextTitle.text = trioTextRight.title.toUpperCase();
        rightTextSubtitle.text = trioTextRight.subtitle.toUpperCase();

        rightTextTitle.x = -rightTextTitle.width;
        rightTextSubtitle.x = -rightTextSubtitle.width;

        leftTextSubtitle.y = leftTextTitle.y + leftTextTitle.height + 4 * props.scale;
        rightTextSubtitle.y = rightTextTitle.y + rightTextTitle.height + 4 * props.scale;

        TweenMax.to([leftText, rightText], 0.2, {
            alpha: 1,
            ease: Quad.easeIn
        });
    },

    onFocus: function(duration, delay)
    {
        if (this.props.solo)
        {
            return;
        }

        TweenMax.to(this.sprites.allTextsContainer, duration, {
            alpha: 1,
            delay: delay
        });
    },

    onBlur: function(duration)
    {
        if (this.props.solo)
        {
            return;
        }

        TweenMax.to(this.sprites.allTextsContainer, duration, {
            alpha: 0
        });
    }
});

module.exports = TrioFunnel;



// WEBPACK FOOTER //
// ./js/components/frames/_common/TrioFunnel.jsx